// eslint-disable-next-line max-classes-per-file
export interface HeartRateParam {
  t1: number;
  t2: number;
  s: number;
  scale: number;
}

interface State {
  trigger: boolean;
  triggerIndex: number;
  max: number;
  maxPoint: number;
  prevPoint: number;
  rate: number;
  param: HeartRateParam;
  result: [number, number][];
}

function proc(state: State, v: number, index: number) {
  const absVal = Math.abs(v);
  if (state.trigger) {
    if (index - state.triggerIndex < state.param.t1) {
      if (absVal > state.max) {
        state.max = absVal;
        state.maxPoint = index;
        return state;
      }
      return state;
    }
    if (index - state.triggerIndex >= state.param.t2) {
      state.trigger = false;
      const rate = 60 / ((state.maxPoint - state.prevPoint) / 1000);
      state.result.push([state.maxPoint, rate]);
      state.prevPoint = state.maxPoint;
      state.max = 0;
      state.maxPoint = 0;
      return state;
    }
    return state;
  }
  if (absVal > (state.param.s / state.param.scale)) {
    state.trigger = true;
    state.triggerIndex = index;
  }
  return state;
}

export function calcHeartRate(reader: FloadReader, param: HeartRateParam) {
  let state: State = {
    max: 0,
    maxPoint: 0,
    trigger: false,
    triggerIndex: 0,
    prevPoint: 0,
    rate: 0,
    param,
    result: [],
  };
  for (let i = 0; i < reader.getLength(); i += 1) {
    const val = reader.next();
    state = proc(state, val, i);
  }
  return state.result;
}

abstract class DataReader<T> {
  view: DataView;
  currentPos = 0;
  currentChunk = 0;
  start: number;
  width: number;
  skip: number;
  length: number;

  constructor(view: DataView, start: number, width: number, skip: number, length: number) {
    this.view = view;
    this.start = start;
    this.width = width;
    this.skip = skip;
    this.length = length;
    this.currentPos = this.start;
  }

  public getLength() {
    return this.length;
  }

  step() {
    this.currentChunk += 1;
    this.currentPos += 1;
    if (this.currentChunk === this.width) {
      this.currentChunk = 0;
      this.currentPos += this.skip;
    }
  }

  public reset() {
    this.currentPos = this.start;
    this.currentChunk = 0;
  }

  public skipFowerd(count: number) {
    for (let i = 0; i < count; i += 1) {
      this.step();
    }
  }

  public chunk(count: number) {
    const ret: T[] = [];
    for (let i = 0; i < count; i += 1) {
      ret.push(this.next());
    }
    return ret;
  }

  public isEnd() {
    return this.currentPos >= this.length;
  }

  public abstract next(): T;
}

export class FloadReader extends DataReader<number> {
  public next() {
    if (this.isEnd()) {
      return 0;
    }
    const val = this.view.getFloat32(this.currentPos * 4, true);
    this.step();
    return val;
  }
}

export class Int8Reader extends DataReader<number> {
  public next() {
    if (this.isEnd()) {
      return 0;
    }
    const val = this.view.getInt8(this.currentPos);
    this.step();
    return val;
  }
}
